const state = () => ({
  logInfo: { isActive: false, remaingSeconds: 15 },
  customerDash: { isActive: true, remainingSeconds: 60 },
  monitoringRegion: { isActive: true, remainingSeconds: 60 },
  dealDashBoard: { isActive: true, remainingSeconds: 60 },
});

const getters = {
  getIsActive: state => key => state[key].isActive,
  getRemainingSeconds: state => state[key].remainingSeconds,
};

const actions = {
  setIsActive({ commit }, { key, isActive }) {
    commit('SET_IS_ACTIVE', { key, isActive });
  },
  setRemainingSeconds({ commit }, { key, remainingSeconds }) {
    commit('SET_REMAINING_SECONDS', { key, remainingSeconds });
  },
};

const mutations = {
  SET_IS_ACTIVE(state, { key, isActive }) {
    if (state[key]) {
      state[key].isActive = isActive;
    }
  },
  SET_REMAINING_SECONDS(state, { key, remainingSeconds }) {
    if (state[key]) {
      state[key].remainingSeconds = remainingSeconds;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
